import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { useCountTime } from 'hooks/useCountTime';

type Threshold = {
  limit: number; // tính bằng giây
  color: string;
};

type Props = {
  prefix?: string;
  time?: string | Date;
  debounce?: number;
  format?: (time: string | Date | undefined) => string;
  thresholds?: Threshold[];
} & TextProps;

const TypographyWaitingTime: React.FC<Props> = ({
  prefix,
  time,
  debounce = 6000,
  format,
  thresholds,
  style,
  ...props
}) => {
  const timeDisplay = useCountTime(time, 1000, format);

  let dynamicColor: string | undefined = undefined;

  if (thresholds && time) {
    const elapsedSeconds = (new Date().getTime() - new Date(time).getTime()) / 1000;

    // lấy threshold có limit lớn nhất mà elapsedSeconds vượt qua
    const matched = thresholds.filter((th) => elapsedSeconds >= th.limit).sort((a, b) => b.limit - a.limit)[0];

    if (matched) {
      dynamicColor = matched.color;
    }
  }

  return (
    <Typography.Text
      {...props}
      style={{
        color: dynamicColor,
        ...style
      }}
    >
      {prefix ? `${prefix} ${timeDisplay}` : timeDisplay}
    </Typography.Text>
  );
};

export default TypographyWaitingTime;
